import {
  getNavigationContext,
  ingestEvent,
  pushEvents,
  updateCurrentNavigationContextInfo
} from '../utils/bridgeCaller';
import PlatformTracker from './PlatformTracker';
import { NavigationContext, FDPEvent } from './types';

export default class MAppTracker extends PlatformTracker {
  protected setNavigationContext(nc: NavigationContext): void {
    updateCurrentNavigationContextInfo(nc);
  }

  protected sendData(): void {
    pushEvents();
  }

  async getNavigationContext() {
    return await getNavigationContext();
  }

  protected storeEvent(event: FDPEvent) {
    ingestEvent(event);
  }
}
